import { css } from 'lit'

export default css`
    .container.has-selected-tags .title {
        margin-bottom: 10px;
    }

    .container .title {
        margin-top: 10px;
    }

    .tags-container {
        font-size: var(--small);
        display: inline-flex;
        flex-wrap: wrap;
        gap: 8px;
        max-width: 100%;
    }

    .input-container {
        position: relative;
    }

    .tag-search {
        outline: none;
        color: var(--grey1);
        font-size: var(--small);
        border: 1px solid transparent;
        border-radius: 4px;
        height: 13px;
        max-width: 150px;
        min-width: 85px;
        padding: 10.5px 0;
    }

    .tag-search::placeholder {
        color: var(--blue-600);
    }

    .tag-search:not(:focus) {
        cursor: pointer;
    }

    .tag-search:placeholder-shown {
        transform: translateY(1px);
    }

    .tag-search:not(:placeholder-shown),
    .tag-search:focus {
        transform: none;
        border-color: var(--grey-400);
        padding: 10.5px 16px;
        min-width: 53px;
    }

    .tag-search:focus::placeholder {
        color: transparent;
    }

    .tag-search-suggestions {
        list-style-type: none;
        border: 1px solid var(--grey5);
        border-radius: 4px;
        display: block;
        padding: 0;
        margin: 7px 0 0;
        width: 300px;
        max-height: 175px;
        overflow: hidden scroll;
        position: absolute;
        z-index: 1000;
    }

    .tag-search-suggestions.align-to-left {
        left: 0;
    }

    .tag-search-suggestions.align-to-right {
        right: 0;
    }

    .tag-search-suggestion {
        margin: 0;
        padding: 12px 16px;
        color: var(--grey1);
        background-color: var(--white);
        cursor: pointer;
    }

    .tag-search-suggestion-new {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .tag-search-suggestion .icon {
        width: 35px;
        height: 35px;
    }

    .tag-search-suggestion:hover {
        background-color: var(--backgroundGrey);
    }
`
